export default "__VITE_ASSET__BAKDzMQu__"